
    import "src/app/AppSeller/SettingsPage/StoreAddress/index.module.scss?farm_css_modules";
    
    export default {"actionButtonsContainer": `actionButtonsContainer-d2fe5151`,"addressList": `addressList-d2fe5151`,"addressPage": `addressPage-d2fe5151`,"container": `container-d2fe5151`,"paginationContainer": `paginationContainer-d2fe5151`,"searchContainer": `searchContainer-d2fe5151`,"wrapperDiv": `wrapperDiv-d2fe5151`}
    